import { render, staticRenderFns } from "./ModalToggleActive.vue?vue&type=template&id=dfc8887a&"
import script from "./ModalToggleActive.vue?vue&type=script&lang=js&"
export * from "./ModalToggleActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports